import { useAuthStore } from "@/stores/authStore"
import { formatCurrency } from "@/lib/currency"

export function useCurrency() {
  const { user } = useAuthStore()
  const currency = user?.default_currency || "EUR"

  return {
    currency,
    format: (amount: number | string) => formatCurrency(amount, currency),
    formatWith: (amount: number | string, curr: string) => formatCurrency(amount, curr),
  }
}
